import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AlertType = 'success' | 'error' | 'warning' | 'info' | 'confirm';

export interface AlertConfig {
  id?: number;
  type: AlertType;
  message: string;
  confirmText?: string;
  cancelText?: string;
  showCancel?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}

@Injectable({ providedIn: 'root' })
export class AlertService {

  private alertSubject = new BehaviorSubject<AlertConfig | null>(null);
  alert$ = this.alertSubject.asObservable();

  private queue: AlertConfig[] = [];
  private isOpen = false;
  private idCounter = 0;

  private currentAlert: AlertConfig | null = null;

  show(config: AlertConfig) {
    config.id = ++this.idCounter;

    if (this.isOpen) {
      this.queue.push(config);
      return;
    }

    this.open(config);
  }

  private open(config: AlertConfig) {
    this.isOpen = true;
    this.currentAlert = config;
    this.alertSubject.next(config);
  }

  close() {
    this.alertSubject.next(null);
    this.currentAlert = null;
    this.isOpen = false;

    if (this.queue.length > 0) {
      const next = this.queue.shift()!;
      setTimeout(() => this.open(next), 0);
    }
  }

  confirmAction() {
    this.currentAlert?.onConfirm?.();
    this.close();
  }

  cancelAction() {
    this.currentAlert?.onCancel?.();
    this.close();
  }

  success(message: string) {
    this.show({ type: 'success', message });
  }

  warning(message: string) {
    this.show({ type: 'warning', message });
  }

  error(message: string) {
    this.show({ type: 'error', message });
  }

  confirm(message: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.show({
        type: 'confirm',
        message,
        showCancel: true,
        confirmText: 'Sim',
        cancelText: 'Não',

        onConfirm: () => resolve(true),
        onCancel: () => resolve(false)
      });
    });
  }
}